<template>
  <div>
    <p class="my-5">Upload video intro text.</p>
    <p class="my-5">
      Upload form will be visible only on devices with camera (mobile, tablet, laptop, desktop with
      camera?).
    </p>
    <p class="my-5">Ask students to install the app and open this section there to upload video.</p>

    <div v-if="allowRecording">
      <video
        id="application-video-player"
        :autoplay="recordingStage == 1"
        :controls="recordingStage == 3"
        ref="video"
      ></video>
      <canvas id="canvas" width="320px" height="240px" ref="canvas"></canvas><br />

      <div style="overflow: hidden; padding: 2rem 0 0">
        <button
          class="btn btn-secondary btn-size-medium includedIcon"
          @click="startRecording"
          v-if="recordingStage == 1"
        >
          <play-icon />Start Recording
        </button>
        <button
          class="btn btn-secondary danger btn-size-medium includedIcon"
          @click="stopRecording"
          v-if="recordingStage == 2"
        >
          <stop-circle-icon />Stop Recording
        </button>
        <template v-if="recordingStage == 3">
          <button
            class="btn btn-secondary danger btn-size-medium includedIcon mr-5"
            @click="removeRecording"
            style="float: left"
          >
            <x-circle-icon />Remove Recording
          </button>
          <button
            class="btn btn-secondary btn-size-medium includedIcon"
            @click="submitData"
            style="float: left"
          >
            <send-icon />Submit Recording
          </button>
        </template>
      </div>
      <vs-progress indeterminate color="primary" v-if="sendingVideo"></vs-progress>
    </div>
    <vs-alert color="success" title="Application Submitted!" active="true" v-if="!allowRecording">
      Your video application is submited! You will be notified when it's approved.
    </vs-alert>
  </div>
</template>

<script>
import cameraMixin from '@/mixins/camera';
import RecordRTC from 'recordrtc';
import store from '@/store/store';
import { PlayIcon, StopCircleIcon, XCircleIcon, SendIcon } from 'vue-feather-icons';

export default {
  components: {
    PlayIcon,
    StopCircleIcon,
    XCircleIcon,
    SendIcon,
  },
  data() {
    return {
      allowRecording: true,
      sendingVideo: false,
      recordingStage: 1,
      videoPlayer: false,
      canvasElement: false,
      recorder: false,
      video: false,
      picture: false,
    };
  },
  methods: {
    initializeMedia() {
      var vm = this;

      this.recordingStage = 1;
      this.videoPlayer = this.$refs.video;
      this.canvasElement = this.$refs.canvas;

      this.video = this.$refs.video;
      if (!('mediaDevices' in navigator)) {
        navigator.mediaDevices = {};
      }
      if (!('getUserMedia' in navigator.mediaDevices)) {
        navigator.mediaDevices.getUserMedia = function (constraints) {
          var getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia;

          if (!getUserMedia) {
            return Promise.reject(new Error('getUserMedia is not implemented!'));
          }

          return new Promise(function (resolve, reject) {
            getUserMedia.call(navigator, constraints, resolve, reject);
          });
        };
      }

      navigator.mediaDevices
        .getUserMedia({ video: true })
        .then((stream) => {
          this.videoPlayer.srcObject = stream;
        })
        .catch(function (err) {
          vm.$vs.dialog({
            title: 'Camera not enabled',
            text: err.message,
            color: 'danger',
          });
        });

      navigator.mediaDevices
        .getUserMedia({
          video: true,
          audio: true,
        })
        .then(async function (stream) {
          let recorder = RecordRTC(stream, {
            type: 'video',
          });
          vm.recorder = recorder;
        });
    },
    startRecording() {
      /*let canvasEl = document.getElementById('canvas');
      let videoEl = document.getElementById('application-video-player');
      canvasEl.style.display = 'block';
      videoEl.style.display = 'none';

      let context = this.canvasElement.getContext('2d');
      // eslint-disable-next-line no-undef
      context.drawImage(this.videoPlayer, 0, 0, canvas.width, this.videoPlayer.videoHeight / (this.videoPlayer.videoWidth / canvas.width));
      this.videoPlayer.srcObject.getVideoTracks().forEach(function (track) {
        track.stop();
      });
      let picture = cameraMixin.methods.dataURItoBlob(this.canvasElement.toDataURL());
      this.picture = picture;*/
      this.recordingStage = 2;
      this.recorder.startRecording();
    },
    stopRecording() {
      var vm = this;
      let videoEl = document.getElementById('application-video-player');

      this.recorder.stopRecording(function () {
        let blob = vm.recorder.blob;
        videoEl.srcObject = null;
        videoEl.src = URL.createObjectURL(blob);
        vm.recorder.stopRecording();

        vm.video = blob;
        vm.recordingStage = 3;
      });
    },
    removeRecording() {
      this.initializeMedia();
    },
    async submitData() {
      this.sendingVideo = true;

      const token = store.getters['authStudent/token'];
      const formData = new FormData();
      formData.append('video', this.video);

      this.sendingVideo = true;
      await fetch($vjeConfig.VUE_APP_API_URL + 'experiences/apply/video', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + token,
        },
        body: formData,
      })
        .then((result) => {
          this.sendingVideo = false;
          if (result.ok) {
            return result.json();
          }
        })
        .then((data) => {
          if (data.status == 'OK') {
            this.allowRecording = false;
            this.recorder = null;
          }
        });
    },
  },
  mixins: [cameraMixin],
  mounted() {
    this.initializeMedia();
  },
};
</script>

<style scoped>
#video {
  background-color: #000000;
}
#canvas {
  display: none;
}
li {
  display: inline;
  padding: 5px;
}
</style>
